<template>
  <BaseModal
    :is-open="isOpen"
    :show-default-footer="false"
    :close-on-overlay-click="true"
    :close-on-escape="true"
    :showCloseButton="true"
    content-padding="none"
    size="sm"
    title="로그인"
    @close="handleClose"
  >
    <div class="gap-size-36 pt-size-24 pb-size-36 flex flex-col px-[50px]">
      <div class="gap-size-12 flex flex-col items-center justify-center">
        <img :src="exampleLoginImage" alt="login" />

        <p class="text-font-16 font-medium">로그인 후 이용해주세요</p>
        <p class="text-font-14">원활한 서비스 이용을 위해 로그인이 필요합니다</p>
      </div>
      <!-- 버튼 영역 -->
      <div class="gap-size-10 flex w-full">
        <BaseButton
          label="회원가입"
          variant="outlined"
          color="black"
          size="md"
          @click="
            () => {
              router.push({ name: 'sign-up' });
              isOpen = false;
            }
          "
        />
        <BaseButton
          label="로그인하러 가기"
          variant="contained"
          color="primary"
          size="md"
          full-width
          @click="
            () => {
              router.push({ name: 'login' });
              isOpen = false;
            }
          "
        />
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import exampleLoginImage from '@/assets/image/dialog/exclamation-mark.png';
import { BaseModal, BaseButton } from '@template/ui';
import { useRouter } from 'vue-router';
const isOpen = defineModel<boolean>('isOpen', { required: true, default: false });
const router = useRouter();
const handleClose = () => {
  isOpen.value = false;
};
</script>
